<template>
  <div>
    <div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="机构名称">
          <el-select v-model="org" filterable placeholder="请输入机构名称" style="display: block" value-key="id">
            <el-option v-for="item in orgData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryCertListByOrg()">查询</el-button>
        </el-form-item>
        <el-form-item label="任教科目">
          <el-select v-model="subject" filterable placeholder="请输入任教科目" style="display: block" value-key="id">
            <el-option v-for="item in subjectData" :key="item.id" :label="item.name" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryCertListBySubject()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportTable()">导出excel列表</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="搜索字段：">
          {{this.searchName}}
        </el-form-item>
        <el-form-item label="证书总数：">
          {{this.tableData.length}}
        </el-form-item>
        <el-form-item label="本年度已复训：">
          {{this.hasTrainCount}}
        </el-form-item>
        <el-form-item label="本年度未复训：">
          {{this.notTrainCount}}
        </el-form-item>
      </el-form>
      <el-table :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" border style="width: 100%" :default-sort="{prop: 'subject', order: 'descending'}" :row-class-name="tableRowClassName" id="out-table">
        <el-table-column fixed prop="serial" label="证书编号" width="130">
        </el-table-column>
        <el-table-column fixed prop="person.name" label="姓名" width="100">
        </el-table-column>
        <el-table-column fixed prop="hasTrain" label="复训状态" width="100">
        </el-table-column>
        <el-table-column prop="person.id_number" label="身份证号" width="200">
        </el-table-column>
        <el-table-column prop="subject" label="任教科目" width="300" style="display: none">
        </el-table-column>
        <el-table-column prop="first_init_time" label="首次领证时间" width="150">
        </el-table-column>
        <el-table-column prop="init_time" label="领证时间" width="150">
        </el-table-column>
        <el-table-column prop="valid_time" label="到期时间" width="150">
        </el-table-column>
        <el-table-column prop="training_record[0].training_time" label="培训时间1" width="150">
        </el-table-column>
        <el-table-column prop="training_record" label="培训时间2" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.training_record.length>='2'">{{scope.row.training_record[1].training_time}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="training_record" label="培训时间3" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.training_record.length>='3'">{{scope.row.training_record[2].training_time}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="training_record.length" label="培训次数" width="80">
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;margin-bottom:10px" background layout="prev, pager, next" :current-page.sync="currentPage" :page-size="20" :total="totalCount">
      </el-pagination>
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  let Base64 = require('js-base64').Base64;
  export default {
    data() {
      return {
        orgData: [],
        subjectData: [],
        tableData: [],
        formModify: {
          name: '',
          legal_person: '',
          legal_person_phone: '',
          director: '',
          director_phone: '',
          address: '',
          email: ''
        },
        org: '',
        subject: '',
        totalCount: 0,
        hasTrainCount: 0,
        notTrainCount: 0,
        currentPage: 1,
        pagesize: 20,
        searchName: ''
      }
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        if (row["hasTrain"] == '已复训') {
          return '';
        } else {
          return 'warning-row';
        }
      },
      queryCertListByOrg: function () {
        this.subject = ''
        this.searchName = this.org.name
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/org_statistic/' + this.org.id + '/')
          .then(response => {
            this.tableData = response.data
            this.totalCount = response.data.length
            this.$options.methods.statisticCert.call(this)
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      queryCertListBySubject: function () {
        this.org = ''
        this.searchName = this.subject.name
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/subject_statistic/' + this.subject.id + '/')
          .then(response => {
            this.tableData = response.data
            this.totalCount = response.data.length
            this.$options.methods.statisticCert.call(this)
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      },
      statisticCert: function() {
        let date = new Date
        let i = 0
        let year = date.getFullYear()
        let tmp = year
        this.hasTrainCount = 0
        this.notTrainCount = 0
        for (i = 0; i < this.tableData.length; i++) {
          tmp = this.tableData[i]["training_record"][this.tableData[i]["training_record"].length - 1]["training_time"]
          tmp = tmp.substring(0, 4)
          if (tmp == year) {
            this.hasTrainCount = this.hasTrainCount + 1
            this.tableData[i]["hasTrain"] = '已复训'
          } else {
            this.notTrainCount = this.notTrainCount + 1
            this.tableData[i]["hasTrain"] = '未复训'
          }
        }
      },
      exportTable: function() {
        if (this.tableData.length == 0) {
          this.$message.error({
            message: '数据列表为空，无法导出',
            center: true
          });
        } else {
          this.pagesize = this.totalCount    //将表格长度变成数据总长度
          this.currentPage = 1          //显示第一页
          this.$nextTick(function () {
            let filename = "导出文件"
            let sheetName = "export"
            let fix = document.querySelector('.el-table__fixed');
            if(fix){ //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
              let wb = XLSX.utils.table_to_book(document.querySelector('#out-table').removeChild(fix), {raw: true});
              document.querySelector('#out-table').appendChild(fix);
              let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
              let blob = new Blob([wbout], { type: 'application/octet-stream' })
              FileSaver.saveAs(blob, filename + '.xlsx')
            } else {
              let wb = XLSX.utils.table_to_book(document.querySelector('#out-table'), {raw: true})
              let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
              let blob = new Blob([wbout], { type: 'application/octet-stream' })
              FileSaver.saveAs(blob, filename + '.xlsx')
            }
            this.pagesize = 20
          })
        }
      },
    },
    mounted: function () {
      if (this.orgData.length === 0) {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/organization/')
          .then(response => {
            this.orgData = response.data
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      }
      if (this.subjectData.length === 0) {
        this.$http
          .get('http://120.27.221.176/backend/api/v1/basic/certificate_subject/?page=1&capacity=100')
          .then(response => {
            this.subjectData = response.data.results
          })
          .catch(error => {
            console.log(error)
            this.$message.error({
              message: '查询失败，请重试',
              center: true
            });
          })
          .finally(() => {

          });
      }
    }
  }
</script>
<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// src/components/Statistic.vue